import React from "react";

const Checkbox = ({ name, label, value=false, disabled, onChange, required, error, checked, pastDate }) => {
    return (
        <>
            <label htmlFor={`input-${name}`} className={`${required ? "input-required" : ""}`}>
                {label}
            </label>
            <div className={`main-list__checkbox ${pastDate ? 'main-list__checkbox--with-color' : ''}`}>
                <input
                    type="checkbox"
                    name={name}
                    id={`input-${name}`}
                    value={value}
                    checked={checked}
                    onChange={onChange}
                    className={`input-disabled ${disabled ? "inactive" : ""}`}
                    disabled={disabled}
                />
                <span></span>
            </div>
            {error && <div className="error-message-text">{error}</div>}
        </>
    );
};

export default Checkbox;
